import { Grid } from '@mui/material'
import { Child } from '../../../../containers/common/child'
import { GItem } from '../grids'
import { UnitTitle } from './unitTitle'
import { getYesNoText } from '../../../../containers/common/category'
import { OperationId } from '../../../../containers/common/constant/operationLog'
import { GetCategoryMstDto } from '../../../../dataAccess/webApi/dto/categoryMstDto'
import { executeGetChildrenDiseaseTest } from '../../../../dataAccess/webApi/dao/childrenDiseaseTestDao'
import { GetChildrenDiseaseTestDto } from '../../../../dataAccess/webApi/dto/childrenDiseaseTestDto'
import { memberModifyChildDiseaseTestUrl } from '../../../../containers/common/constant/appUrl'

const HOSPITAL_ADMISSION = 'diseaseTest'
const SUB_CATEGORIES = ['diseaseTest.testName', 'diseaseTest.testDate', 'diseaseTest.testResult']
export const CATEGORY_NAMES = [HOSPITAL_ADMISSION, ...SUB_CATEGORIES]

interface ChildDiseaseTestUnitProps {
  child?: Child
  sectionLabel: string
  categoryMst?: GetCategoryMstDto[]
  hideLink?: boolean  
}

export const ChildDiseaseTestUnit = (props: ChildDiseaseTestUnitProps) => {
  const { categoryMst, child, sectionLabel } = props
  const MAX_RECORD = 2

  if (child == null || categoryMst == null || categoryMst.length === 0) return null
  
  const diseaseTestCategory = categoryMst.find((value) => value.category === HOSPITAL_ADMISSION)
  const subCategories = categoryMst.filter((mst) => SUB_CATEGORIES.includes(mst.category))
 
  if (!diseaseTestCategory || subCategories.length === 0) return null
  
  const subCategoryMap: {[key:string]: GetCategoryMstDto} = {}
  subCategories?.forEach(e => subCategoryMap[e.category.substring(HOSPITAL_ADMISSION.length + 1)] = e)
  
  const filteredDiseaseTest = child.diseaseTest?.filter(diseaseTest => {
    return diseaseTest.code === '99' || diseaseTest.testDate != null || (diseaseTest.testResult != null && diseaseTest.testResult !== "")
  })
  
  const recordCnt = filteredDiseaseTest?.length ?? 0
  return (
    <>
      <UnitTitle title={sectionLabel} linkTo={memberModifyChildDiseaseTestUrl.url(child.childId)} operationLog={{ operationId: OperationId.OP_00000181 }} hideLink={props.hideLink} />
      <Grid container>
        { recordCnt === 0 ? (
          <GItem xs={12}>{getYesNoText(diseaseTestCategory, undefined)}</GItem>
        ) : (
          filteredDiseaseTest?.slice(0, MAX_RECORD).map((diseaseTest, i) => {
            return (<DataRow
              key={`diseaseTest${i}`}
              categoryMap={subCategoryMap}
              diseaseTest={diseaseTest}
            />)
          })
        )}
        { recordCnt > MAX_RECORD && <GItem xs={12}>...</GItem> }
      </Grid>
    </>
  )
}

interface DataRowProps {
  categoryMap: {[key:string]: GetCategoryMstDto}
  diseaseTest: GetChildrenDiseaseTestDto
}

const DataRow = ({ categoryMap, diseaseTest }: DataRowProps) => {
  return (
    <>
      {categoryMap.testName && <GItem xs={3} md={3}>{diseaseTest.testName}</GItem>}
      {categoryMap.testDate && <GItem xs={2} md={2}>{diseaseTest.testDate}</GItem>}
      {categoryMap.testResult && <GItem xs={7} md={7}>{getTestResultName(categoryMap.testResult, diseaseTest.testResult)}</GItem>}
    </>
  )
}

const getTestResultName = (testResultMst:GetCategoryMstDto, testResult:string | null | undefined) => {
  if(testResult == null){
    return null
  }
  const targetOption = testResultMst.options?.find((opt) => opt.code=== testResult)
  return targetOption?.optionName
}

/**
 * 検査情報を取得
 */
export const resetDiseaseTest = async (id: string, facilityId: string, baseObj: any) => {
  const resp = await executeGetChildrenDiseaseTest(id, facilityId)
  baseObj.diseaseTest = resp.result
}